import {injectable, inject} from "tsyringe";
import { IUserService } from "$src/domain/users/IUserService";
import type { IUserRepository } from "$src/domain/users/IUserRepository";
import { UserSummary } from "$src/domain/users/UserSummary";
import { UserGroupStoreAccess } from "$src/domain/users/UserGroupStoreAccess";


@injectable()
export class UserService implements IUserService {

    private userRepository: IUserRepository;

    constructor(@inject("IUserRepository") customerRepository: IUserRepository) {
        this.userRepository = customerRepository;
    }

    async getMe(): Promise<UserSummary> {
        return await this.userRepository.getMe();
    }

    async getMyGroupStores(): Promise<UserGroupStoreAccess> {
        return await this.userRepository.getMyGroupStores();
    }
}
